<template>
  <v-container>
      <h2 class="mb-4 ml-4">Add A Song</h2>
    <vue-good-wizard
      class="elevation-11 pa-2"
      :steps="steps"
      :onNext="nextClicked"
      :onBack="backClicked"
      finalStepLabel = "Save Song">

      <div slot="page1" class="entry">
        <h4 class="mb-3">Enter Song title</h4>
        <v-text-field
          v-model.trim="title"
          label="Song title"
          id="title"
          autofocus
          required
        ></v-text-field>
        <v-btn small @click="$router.go(-1)" class="ml-0 mt-4 mb-0">cancel</v-btn>
      </div>

      <div slot="page2" class="entry">
        <h4 class="mb-5">Enter Artist</h4>
        <v-text-field
          v-model.trim="artist"
          label="Artist name"
          id="artist"
          v-focus
          required
        ></v-text-field>
      </div>

      <div slot="page3" class="entry">
          <h4 class="mb-3">Notes</h4>
        <v-textarea
            v-model.trim="notes"
            label="Notes"
            ref="notes"
            id="notes"
            autofocus
            class="mt-5"
            required
        ></v-textarea>
      </div>

      <div slot="page4" class="summary">
        <h3>Your songlist entry</h3>
        <hr class="mt-2 mb-3"/>
        <p>Song title: {{title}}</p>
        <p>Artist: {{artist}}</p>
        <p>Notes: {{notes}}</p>
      </div>

    </vue-good-wizard>
  </v-container>
</template>

<script>
import { generateUUID } from '../../mixins/utilities.js'
export default {
  name: "demo",
  mounted() {
    this.artist = ""
    this.title = ""
    this.notes = ""
  },
  data() {
    return {
      steps: [
        {
          label: "Song Name",
          slot: "page1"
        },
        {
          label: "Artist Name",
          slot: "page2"
        },
        {
          label: "Notes",
          slot: "page3"
        },
        {
          label: "Summary",
          slot: "page4"
        }
      ],
      title: "",
      artist: "",
      notes: ""
    };
  },
  methods: {
    nextClicked(currentPage) {
      switch (currentPage) {
        case 0:
          if (this.title === "") {
            alert("Please enter a song title");
            document.getElementById("title").focus();
            return false;
          }
          break;

        case 1:
          if (this.artist === "") {
            alert("Please enter an artists' name");
            document.getElementById("artist").focus();
            return false;
          }
          break;

        case 2:
          // if (this.notes === "") {
          //   alert("Please enter notes for this song");
          //   document.getElementById("notes").focus();
          //   return false;
          // }
          break;
        case 3:
          const objSong = {
            artist: this.artist,
            title: this.title,
            notes: this.notes,
            songId: generateUUID()
          }

          this.$store.dispatch('addToSonglist', objSong)
          this.$router.push('/songlists')
          break;

        default:
          break;
      }
      return true; //return false if you want to prevent moving to next page
    },
    backClicked(currentPage) {
      if (currentPage <= 7) {
        return true;
      }
      return false; //return false if you want to prevent moving to previous page
    }
  }
};
</script>

<style scoped>
.container {
  padding: 0px;
}

h2{
  font-size: 1.5rem;
  font-weight: bold;
}

a {
  margin-bottom: 50px;
}

p {
  margin-left: 0;
}
.entry {
  padding: 10px;
}

textarea {
  width: 100%;
  padding: 0;
  font-size: 0.85rem;
  height: 300px;
  overflow: auto;
}

.title {
  margin-left: auto;
  margin-right: auto;
  margin-top: 0;
}

.summary {
  margin: 60px;
}
</style>

